module.exports = __webpack_public_path__ + "img/rungis_market_30s.fb2d46ae.jpg";